import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../../../constants/common'
import { getQaSelector } from '../../../../../../utils/common'
import Text from '../../../../../Text'
import { TextareaElement } from '../../../../../Textarea'

import { QA_NAME_VIEWING_OUTCOME_NOTE } from './ViewingStatusChangeNote.constants'

import * as styles from './ViewingStatusChangeNote.module.css'

function ViewingStatusChangeNote({ noteRef }) {
  const { t } = useTranslation()

  const [note, setNote] = useState(EMPTY_STRING)

  function handleChange(value) {
    setNote(value)

    noteRef.current = value
  }

  return (
    <div
      {...getQaSelector({ value: QA_NAME_VIEWING_OUTCOME_NOTE })}
      className={styles.ViewingStatusChangeNote}
    >
      <Text isSecondary>{t('RentalPortal.ViewingNoShowNoteLabelKey')}</Text>
      <TextareaElement
        autoResizeHeight
        placeholder={t('RentalPortal.ViewingNoShowNotePlaceholderKey')}
        value={note}
        onChange={handleChange}
      />
    </div>
  )
}

export default ViewingStatusChangeNote
